import * as React from "react";
const VerifiedIcon = (props) => (
  <svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.8896 3C28.1986 3.00016 30.9748 5.27661 31.7402 8.34863C34.4538 6.71729 38.0272 7.07127 40.3672 9.41113C42.7073 11.7512 43.0603 15.3244 41.4287 18.0381C44.5015 18.8031 46.7783 21.5801 46.7783 24.8896C46.7782 28.199 44.5013 30.9753 41.4287 31.7402C43.0605 34.4539 42.7073 38.027 40.3672 40.3672C38.027 42.7073 34.4539 43.0605 31.7402 41.4287C30.9753 44.5013 28.199 46.7782 24.8896 46.7783C21.5801 46.7783 18.8031 44.5015 18.0381 41.4287C15.3244 43.0603 11.7512 42.7073 9.41113 40.3672C7.07126 38.0272 6.71729 34.4538 8.34863 31.7402C5.27661 30.9748 3.00016 28.1986 3 24.8896C3 21.5805 5.27647 18.8035 8.34863 18.0381C6.7174 15.3245 7.0712 11.7511 9.41113 9.41113C11.7511 7.0712 15.3245 6.7174 18.0381 8.34863C18.8035 5.27647 21.5805 3 24.8896 3ZM34.1602 17.6289C33.7588 17.277 33.1519 17.3024 32.7812 17.6865L23.6123 27.1895C23.23 27.5856 22.6 27.5983 22.2021 27.2178L18.3115 23.4961C17.9172 23.119 17.2929 23.1278 16.9092 23.5156L15.7285 24.71C15.3306 25.1125 15.3456 25.7648 15.7617 26.1484L22.4697 32.3262C22.8745 32.6987 23.5042 32.6743 23.8789 32.2715L35.2988 19.9961C35.6828 19.5833 35.6495 18.9342 35.2256 18.5625L34.1602 17.6289Z"
      fill="#4CAF50"
    />
  </svg>
);
export default VerifiedIcon;
